import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex-center flex-col h-full w-full items-center justify-center p-4 text-4xl"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", {
  class: "mb-8"
}, "footy", -1);
const _hoisted_3 = {
  class: "mb-8 text-base text-slate-600"
};
import { app } from "@/di";
import AssetLoader from "@/modules/vue/services/AssetLoader";
import { ConfigRepository } from "@/modules/base/services/ConfigRepository";
export default /*#__PURE__*/_defineComponent({
  __name: 'Load',
  setup(__props) {
    const props = __props;
    const router = useRouter();
    const progress = ref(0);
    const isFinished = computed(() => progress.value === 100);
    onMounted(async () => {
      await waitFor(app.get(ConfigRepository).get('ui.loadingScreen.waitBefore'));
      await app.get(AssetLoader).loadApp(p => progress.value = Math.floor(p));
      await waitFor(app.get(ConfigRepository).get('ui.loadingScreen.waitAfter'));
      router.push({
        name: 'main-menu.index'
      });
    });
    return (_ctx, _cache) => {
      const _component_NProgress = _resolveComponent("NProgress");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_NProgress, {
        type: "circle",
        percentage: progress.value,
        class: "mb-4"
      }, null, 8, ["percentage"]), _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(isFinished) ? _ctx.$t('done') : _ctx.$t('loading...')), 1)]);
    };
  }
});